const { validator } = require('./validator');
const inOutFormatDecorator = require('./validator').inOutFormatDecorator;

const createCoverLetter = {
    id: { type: 'ID' },
    userId: { type: 'stringID' },
    template: {
        type: 'string',
        presence: {
            allowEmpty: false
        }
    },
    title: {
        length: {
            maximum: 60
        }
    }
};

const updateCoverLetter = {
    id: { type: 'ID' },
    userId: { type: 'stringID' },
    template: {
        type: 'string'
    },
    title: {
        length: {
            maximum: 60
        }
    },
    body: { type: 'string' }
};

const duplicateCoverLetter = {
    id: { type: 'ID' },
    userId: { type: 'stringID' },
    title: {
        length: {
            maximum: 60
        }
    }
};

const contactDetails = {
    email: { type: 'string' },
    phone: { type: 'string' },
    firstName: { type: 'string' },
    lastName: { type: 'string' },
    jobCategory: { type: 'string' }
};

const updateFooter = {
    id: { type: 'ID' },
    userId: {
        type: 'stringID',
        presence: {
            allowEmpty: false
        }
    },
    footer: { type: 'string' }
};

module.exports = {
    createCoverLetter: {
        schema: createCoverLetter,
        validate: inOutFormatDecorator(validator, createCoverLetter)
    },
    duplicateCoverLetter: {
        schema: duplicateCoverLetter,
        validate: inOutFormatDecorator(validator, duplicateCoverLetter)
    },
    contactDetails: {
        schema: contactDetails,
        validate: inOutFormatDecorator(validator, contactDetails)
    },
    updateFooter: {
        schema: updateFooter,
        validate: inOutFormatDecorator(validator, updateFooter)
    },
    updateCoverLetter: {
        schema: updateCoverLetter,
        validate: inOutFormatDecorator(validator, updateCoverLetter)
    }
};
